var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Avatar, Box, Button, Divider, FormControl, FormControlLabel, Grid, IconButton, ListItemAvatar, Menu, MenuItem, MenuList, Radio, RadioGroup, Stack, Typography, useMediaQuery } from "@mui/material";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Post } from "../../api/api";
import { DownloadProfilePicUrl, USER_PROFILE_DATA, assignedMenusByGroupURL, assignedModulesURL, getProductIssueConfigurationURL, getUserProfileUrl, logOutURL } from "../../api/url";
import { HeaderBellIcon, HeaderSearchIcon, PlusHeaderIcon } from "../../assets/customIcons";
import { DotsVerticalIcon, FeaturedRedIcon, HelpIcon, ProfileIcon, logOutNew } from '../../assets/images';
import { ReactComponent as HomeIcon } from "../../assets/images/homeIcon.svg";
import { setRbacStorage } from "../../builderPackage/rbac/rbac.entity";
import { ESystemName, EUserRole, E_NEW_DOCUMENT_MENU_LIST, LOCAL_STORAGE_KEYS, Module, SPARE_ISSUE_ENUM, dateBeforeMonth, dateBeforeWeek, helpUrl, isModuleConfig } from "../../constants";
import Profile from "../../modules/profile/profile";
import { ChitraLogout } from "../../modules/reports/utils";
import { resetAfterLogOutAuth } from "../../redux/authSlice";
import { downloadProfileAttachment, moduleSectionsByChannelFunction, resetCommonReducer, setIsAllViewActive, setSelectedDesignation, showLoader, showSuccess } from "../../redux/commonSlice";
import { getByIdAPI, getListAPI, resetAfterLogOutCrud, setReducerState, setState } from "../../redux/crudSlice";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { systemColor } from "../../theme/systemColor";
import { clearLocalStorage, getLocalStorageItem, getUserAuthToken, setLocalStorageItem } from "../../utils/storageHelper";
import { isNullOrEmpty } from "../../utils/validationHelper";
import { MuiButton } from "../atoms/buttonComponent";
import { MuiIconButton } from "../atoms/iconButtonComponent";
import { MuiLoaderButton } from "../atoms/loaderButton";
import { MuiStack } from "../atoms/stackComponent";
import { MuiPopup } from "../molecules/popupComponent";
import { env } from "../../api/config";
export var HeaderMenus = function (props) {
    var _userData$data, _userData$data2, _userData$data3, _userData$data5, _userData$data6, _userData$data7, _userData$data8, _userData$data9, _Object$values;
    var lgMode = useMediaQuery(function (theme) { return theme.breakpoints.up('sm'); });
    var IS_DESKTOP = useMediaQuery(function (theme) { return theme.breakpoints.up("md"); });
    var upSM = useMediaQuery(function (theme) { return theme.breakpoints.up("sm"); });
    var dowMd = useMediaQuery(function (theme) { return theme.breakpoints.down("md"); });
    var IS_TABLET = upSM && dowMd;
    var upXS = useMediaQuery(function (theme) { return theme.breakpoints.up("xs"); });
    var downSM = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var _a = useState(false), profileClick = _a[0], setProfileClick = _a[1];
    var _b = useState(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var _c = useState(null), addIconAnchorEl = _c[0], setAddIconAnchorEl = _c[1];
    var open = Boolean(anchorEl);
    var openNewDocumentsMenu = Boolean(addIconAnchorEl);
    var crud = useAppSelector(function (state) { return state.crud; });
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var userData = getLocalStorageItem(USER_PROFILE_DATA);
    var showRoles = (userData === null || userData === void 0 || (_userData$data = userData.data) === null || _userData$data === void 0 || (_userData$data = _userData$data.AssignedRole) === null || _userData$data === void 0 ? void 0 : _userData$data.length) > 0 && ((userData === null || userData === void 0 || (_userData$data2 = userData.data) === null || _userData$data2 === void 0 ? void 0 : _userData$data2.AssignedRole.length) > 1 || (userData === null || userData === void 0 || (_userData$data3 = userData.data) === null || _userData$data3 === void 0 || (_userData$data3 = _userData$data3.AssignedRole[0]) === null || _userData$data3 === void 0 ? void 0 : _userData$data3.Name) !== EUserRole.Default);
    var selectedDesignation = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_DESIGNATION);
    var _d = useState(''), value = _d[0], setValue = _d[1];
    var _e = useState(false), isSignOut = _e[0], setIsSignOut = _e[1];
    var _f = useState(false), roleEmpty = _f[0], setRoleEmpty = _f[1];
    var assignedMenus = getLocalStorageItem(LOCAL_STORAGE_KEYS.ASSIGNED_MENUS);
    var ProfilePicUrl = useAppSelector(function (state) { return state.crud; }).ProfilePicUrl;
    var storedSelectedChannel = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_CHANNEL);
    var storedSelectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    var rbac = getLocalStorageItem(LOCAL_STORAGE_KEYS.RBAC);
    var loader = useAppSelector(function (state) { return state.common.isLoader; });
    useEffect(function () {
        getUserProfileDetails();
        // getProductIssueConfiguration()
    }, [profileClick]);
    useEffect(function () {
        getProductIssueConfiguration();
    }, []);
    var getModuleSectionByChannel = function (selectedDesignationStorage) { return __awaiter(void 0, void 0, void 0, function () {
        var finalInspectionAS, appointmentAS, estimateAS, revisedEstimateAS, inspectionAS, jobCardAS, _finalInspectionResul, _finalInspectionResul2, _jobCardResult$payloa, _jobCardResult$payloa2, _estimateResult$paylo, _estimateResult$paylo2, _revisedEstimateResul, _revisedEstimateResul2, _a, finalInspectionResult, jobCardResult, estimateResult, revisedEstimateResult, _finalInspectionResul3, _jobCardResult$payloa3, _jobCardResult$payloa4, _estimateResult$paylo3, _revisedEstimateResul3, _appointmentResult$pa, _appointmentResult$pa2, _estimateResult$paylo4, _estimateResult$paylo5, _revisedEstimateResul4, _revisedEstimateResul5, _inspectionResult$pay, _inspectionResult$pay2, _jobCardResult$payloa5, _jobCardResult$payloa6, _finalInspectionResul4, _finalInspectionResul5, _b, appointmentResult, estimateResult, revisedEstimateResult, inspectionResult, jobCardResult, finalInspectionResult, _appointmentResult$pa3, _estimateResult$paylo6, _revisedEstimateResul6, _inspectionResult$pay3, _jobCardResult$payloa7, _finalInspectionResul6;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, getLocalStorageItem(LOCAL_STORAGE_KEYS.MODULE_SECTION_FINALINSPECTION)];
                case 1:
                    finalInspectionAS = _c.sent();
                    return [4 /*yield*/, getLocalStorageItem(LOCAL_STORAGE_KEYS.MODULE_SECTION_APPOINTMENT)];
                case 2:
                    appointmentAS = _c.sent();
                    return [4 /*yield*/, getLocalStorageItem(LOCAL_STORAGE_KEYS.MODULE_SECTION_ESTIMATE)];
                case 3:
                    estimateAS = _c.sent();
                    return [4 /*yield*/, getLocalStorageItem(LOCAL_STORAGE_KEYS.MODULE_SECTION_REVISEDESTIMATE)];
                case 4:
                    revisedEstimateAS = _c.sent();
                    return [4 /*yield*/, getLocalStorageItem(LOCAL_STORAGE_KEYS.MODULE_SECTION_INSPECTION)];
                case 5:
                    inspectionAS = _c.sent();
                    return [4 /*yield*/, getLocalStorageItem(LOCAL_STORAGE_KEYS.MODULE_SECTION_JOBCARD)];
                case 6:
                    jobCardAS = _c.sent();
                    if (!((selectedDesignationStorage === null || selectedDesignationStorage === void 0 ? void 0 : selectedDesignationStorage.Name) == EUserRole.FinalInspector && (isNullOrEmpty(finalInspectionAS) || isNullOrEmpty(estimateAS) || isNullOrEmpty(revisedEstimateAS) || isNullOrEmpty(jobCardAS)))) return [3 /*break*/, 8];
                    return [4 /*yield*/, Promise.all([dispatch(moduleSectionsByChannelFunction({
                                request: {
                                    ModuleEntityId: ESystemName.FinalInspection
                                }
                            })), dispatch(moduleSectionsByChannelFunction({
                                request: {
                                    ModuleEntityId: ESystemName.Jobcard
                                }
                            })), dispatch(moduleSectionsByChannelFunction({
                                request: {
                                    ModuleEntityId: ESystemName.Estimate
                                }
                            })), dispatch(moduleSectionsByChannelFunction({
                                request: {
                                    ModuleEntityId: ESystemName.RevisedEstimate
                                }
                            }))])];
                case 7:
                    _a = _c.sent(), finalInspectionResult = _a[0], jobCardResult = _a[1], estimateResult = _a[2], revisedEstimateResult = _a[3];
                    if (finalInspectionResult !== null && finalInspectionResult !== void 0 && (_finalInspectionResul = finalInspectionResult.payload) !== null && _finalInspectionResul !== void 0 && (_finalInspectionResul = _finalInspectionResul.payload) !== null && _finalInspectionResul !== void 0 && (_finalInspectionResul = _finalInspectionResul.value) !== null && _finalInspectionResul !== void 0 && _finalInspectionResul.success && (finalInspectionResult === null || finalInspectionResult === void 0 || (_finalInspectionResul2 = finalInspectionResult.payload) === null || _finalInspectionResul2 === void 0 || (_finalInspectionResul2 = _finalInspectionResul2.payload) === null || _finalInspectionResul2 === void 0 || (_finalInspectionResul2 = _finalInspectionResul2.value) === null || _finalInspectionResul2 === void 0 ? void 0 : _finalInspectionResul2.statusCode) == 200) {
                        setLocalStorageItem(LOCAL_STORAGE_KEYS.MODULE_SECTION_FINALINSPECTION, finalInspectionResult === null || finalInspectionResult === void 0 || (_finalInspectionResul3 = finalInspectionResult.payload) === null || _finalInspectionResul3 === void 0 || (_finalInspectionResul3 = _finalInspectionResul3.payload) === null || _finalInspectionResul3 === void 0 || (_finalInspectionResul3 = _finalInspectionResul3.value) === null || _finalInspectionResul3 === void 0 ? void 0 : _finalInspectionResul3.data);
                    }
                    if (jobCardResult !== null && jobCardResult !== void 0 && (_jobCardResult$payloa = jobCardResult.payload) !== null && _jobCardResult$payloa !== void 0 && (_jobCardResult$payloa = _jobCardResult$payloa.payload) !== null && _jobCardResult$payloa !== void 0 && (_jobCardResult$payloa = _jobCardResult$payloa.value) !== null && _jobCardResult$payloa !== void 0 && _jobCardResult$payloa.success && (jobCardResult === null || jobCardResult === void 0 || (_jobCardResult$payloa2 = jobCardResult.payload) === null || _jobCardResult$payloa2 === void 0 || (_jobCardResult$payloa2 = _jobCardResult$payloa2.payload) === null || _jobCardResult$payloa2 === void 0 || (_jobCardResult$payloa2 = _jobCardResult$payloa2.value) === null || _jobCardResult$payloa2 === void 0 ? void 0 : _jobCardResult$payloa2.statusCode) === 200) {
                        setLocalStorageItem(LOCAL_STORAGE_KEYS.MODULE_SECTION_JOBCARD, (_jobCardResult$payloa3 = jobCardResult === null || jobCardResult === void 0 || (_jobCardResult$payloa4 = jobCardResult.payload) === null || _jobCardResult$payloa4 === void 0 || (_jobCardResult$payloa4 = _jobCardResult$payloa4.payload) === null || _jobCardResult$payloa4 === void 0 || (_jobCardResult$payloa4 = _jobCardResult$payloa4.value) === null || _jobCardResult$payloa4 === void 0 ? void 0 : _jobCardResult$payloa4.data) !== null && _jobCardResult$payloa3 !== void 0 ? _jobCardResult$payloa3 : []);
                    }
                    //Estimate result
                    if (estimateResult !== null && estimateResult !== void 0 && (_estimateResult$paylo = estimateResult.payload) !== null && _estimateResult$paylo !== void 0 && (_estimateResult$paylo = _estimateResult$paylo.payload) !== null && _estimateResult$paylo !== void 0 && (_estimateResult$paylo = _estimateResult$paylo.value) !== null && _estimateResult$paylo !== void 0 && _estimateResult$paylo.success && (estimateResult === null || estimateResult === void 0 || (_estimateResult$paylo2 = estimateResult.payload) === null || _estimateResult$paylo2 === void 0 || (_estimateResult$paylo2 = _estimateResult$paylo2.payload) === null || _estimateResult$paylo2 === void 0 || (_estimateResult$paylo2 = _estimateResult$paylo2.value) === null || _estimateResult$paylo2 === void 0 ? void 0 : _estimateResult$paylo2.statusCode) == 200) {
                        setLocalStorageItem(LOCAL_STORAGE_KEYS.MODULE_SECTION_ESTIMATE, estimateResult === null || estimateResult === void 0 || (_estimateResult$paylo3 = estimateResult.payload) === null || _estimateResult$paylo3 === void 0 || (_estimateResult$paylo3 = _estimateResult$paylo3.payload) === null || _estimateResult$paylo3 === void 0 || (_estimateResult$paylo3 = _estimateResult$paylo3.value) === null || _estimateResult$paylo3 === void 0 ? void 0 : _estimateResult$paylo3.data);
                    }
                    //RevisedEstimate result
                    if (revisedEstimateResult !== null && revisedEstimateResult !== void 0 && (_revisedEstimateResul = revisedEstimateResult.payload) !== null && _revisedEstimateResul !== void 0 && (_revisedEstimateResul = _revisedEstimateResul.payload) !== null && _revisedEstimateResul !== void 0 && (_revisedEstimateResul = _revisedEstimateResul.value) !== null && _revisedEstimateResul !== void 0 && _revisedEstimateResul.success && (revisedEstimateResult === null || revisedEstimateResult === void 0 || (_revisedEstimateResul2 = revisedEstimateResult.payload) === null || _revisedEstimateResul2 === void 0 || (_revisedEstimateResul2 = _revisedEstimateResul2.payload) === null || _revisedEstimateResul2 === void 0 || (_revisedEstimateResul2 = _revisedEstimateResul2.value) === null || _revisedEstimateResul2 === void 0 ? void 0 : _revisedEstimateResul2.statusCode) == 200) {
                        setLocalStorageItem(LOCAL_STORAGE_KEYS.MODULE_SECTION_REVISEDESTIMATE, revisedEstimateResult === null || revisedEstimateResult === void 0 || (_revisedEstimateResul3 = revisedEstimateResult.payload) === null || _revisedEstimateResul3 === void 0 || (_revisedEstimateResul3 = _revisedEstimateResul3.payload) === null || _revisedEstimateResul3 === void 0 || (_revisedEstimateResul3 = _revisedEstimateResul3.value) === null || _revisedEstimateResul3 === void 0 ? void 0 : _revisedEstimateResul3.data);
                    }
                    return [3 /*break*/, 10];
                case 8:
                    if (!(isNullOrEmpty(appointmentAS) || isNullOrEmpty(estimateAS) || isNullOrEmpty(revisedEstimateAS) || isNullOrEmpty(inspectionAS) || isNullOrEmpty(jobCardAS) || isNullOrEmpty(finalInspectionAS))) return [3 /*break*/, 10];
                    return [4 /*yield*/, Promise.all([dispatch(moduleSectionsByChannelFunction({
                                request: {
                                    ModuleEntityId: ESystemName.Appointment
                                }
                            })), dispatch(moduleSectionsByChannelFunction({
                                request: {
                                    ModuleEntityId: ESystemName.Estimate
                                }
                            })), dispatch(moduleSectionsByChannelFunction({
                                request: {
                                    ModuleEntityId: ESystemName.RevisedEstimate
                                }
                            })), dispatch(moduleSectionsByChannelFunction({
                                request: {
                                    ModuleEntityId: ESystemName.Inspection
                                }
                            })), dispatch(moduleSectionsByChannelFunction({
                                request: {
                                    ModuleEntityId: ESystemName.Jobcard
                                }
                            })), dispatch(moduleSectionsByChannelFunction({
                                request: {
                                    ModuleEntityId: ESystemName.FinalInspection
                                }
                            }))])];
                case 9:
                    _b = _c.sent(), appointmentResult = _b[0], estimateResult = _b[1], revisedEstimateResult = _b[2], inspectionResult = _b[3], jobCardResult = _b[4], finalInspectionResult = _b[5];
                    //Appointment result
                    if (appointmentResult !== null && appointmentResult !== void 0 && (_appointmentResult$pa = appointmentResult.payload) !== null && _appointmentResult$pa !== void 0 && (_appointmentResult$pa = _appointmentResult$pa.payload) !== null && _appointmentResult$pa !== void 0 && (_appointmentResult$pa = _appointmentResult$pa.value) !== null && _appointmentResult$pa !== void 0 && _appointmentResult$pa.success && (appointmentResult === null || appointmentResult === void 0 || (_appointmentResult$pa2 = appointmentResult.payload) === null || _appointmentResult$pa2 === void 0 || (_appointmentResult$pa2 = _appointmentResult$pa2.payload) === null || _appointmentResult$pa2 === void 0 || (_appointmentResult$pa2 = _appointmentResult$pa2.value) === null || _appointmentResult$pa2 === void 0 ? void 0 : _appointmentResult$pa2.statusCode) == 200) {
                        setLocalStorageItem(LOCAL_STORAGE_KEYS.MODULE_SECTION_APPOINTMENT, appointmentResult === null || appointmentResult === void 0 || (_appointmentResult$pa3 = appointmentResult.payload) === null || _appointmentResult$pa3 === void 0 || (_appointmentResult$pa3 = _appointmentResult$pa3.payload) === null || _appointmentResult$pa3 === void 0 || (_appointmentResult$pa3 = _appointmentResult$pa3.value) === null || _appointmentResult$pa3 === void 0 ? void 0 : _appointmentResult$pa3.data);
                    }
                    //Estimate result
                    if (estimateResult !== null && estimateResult !== void 0 && (_estimateResult$paylo4 = estimateResult.payload) !== null && _estimateResult$paylo4 !== void 0 && (_estimateResult$paylo4 = _estimateResult$paylo4.payload) !== null && _estimateResult$paylo4 !== void 0 && (_estimateResult$paylo4 = _estimateResult$paylo4.value) !== null && _estimateResult$paylo4 !== void 0 && _estimateResult$paylo4.success && (estimateResult === null || estimateResult === void 0 || (_estimateResult$paylo5 = estimateResult.payload) === null || _estimateResult$paylo5 === void 0 || (_estimateResult$paylo5 = _estimateResult$paylo5.payload) === null || _estimateResult$paylo5 === void 0 || (_estimateResult$paylo5 = _estimateResult$paylo5.value) === null || _estimateResult$paylo5 === void 0 ? void 0 : _estimateResult$paylo5.statusCode) == 200) {
                        setLocalStorageItem(LOCAL_STORAGE_KEYS.MODULE_SECTION_ESTIMATE, estimateResult === null || estimateResult === void 0 || (_estimateResult$paylo6 = estimateResult.payload) === null || _estimateResult$paylo6 === void 0 || (_estimateResult$paylo6 = _estimateResult$paylo6.payload) === null || _estimateResult$paylo6 === void 0 || (_estimateResult$paylo6 = _estimateResult$paylo6.value) === null || _estimateResult$paylo6 === void 0 ? void 0 : _estimateResult$paylo6.data);
                    }
                    //RevisedEstimate result
                    if (revisedEstimateResult !== null && revisedEstimateResult !== void 0 && (_revisedEstimateResul4 = revisedEstimateResult.payload) !== null && _revisedEstimateResul4 !== void 0 && (_revisedEstimateResul4 = _revisedEstimateResul4.payload) !== null && _revisedEstimateResul4 !== void 0 && (_revisedEstimateResul4 = _revisedEstimateResul4.value) !== null && _revisedEstimateResul4 !== void 0 && _revisedEstimateResul4.success && (revisedEstimateResult === null || revisedEstimateResult === void 0 || (_revisedEstimateResul5 = revisedEstimateResult.payload) === null || _revisedEstimateResul5 === void 0 || (_revisedEstimateResul5 = _revisedEstimateResul5.payload) === null || _revisedEstimateResul5 === void 0 || (_revisedEstimateResul5 = _revisedEstimateResul5.value) === null || _revisedEstimateResul5 === void 0 ? void 0 : _revisedEstimateResul5.statusCode) == 200) {
                        setLocalStorageItem(LOCAL_STORAGE_KEYS.MODULE_SECTION_REVISEDESTIMATE, revisedEstimateResult === null || revisedEstimateResult === void 0 || (_revisedEstimateResul6 = revisedEstimateResult.payload) === null || _revisedEstimateResul6 === void 0 || (_revisedEstimateResul6 = _revisedEstimateResul6.payload) === null || _revisedEstimateResul6 === void 0 || (_revisedEstimateResul6 = _revisedEstimateResul6.value) === null || _revisedEstimateResul6 === void 0 ? void 0 : _revisedEstimateResul6.data);
                    }
                    //inspection result
                    if (inspectionResult !== null && inspectionResult !== void 0 && (_inspectionResult$pay = inspectionResult.payload) !== null && _inspectionResult$pay !== void 0 && (_inspectionResult$pay = _inspectionResult$pay.payload) !== null && _inspectionResult$pay !== void 0 && (_inspectionResult$pay = _inspectionResult$pay.value) !== null && _inspectionResult$pay !== void 0 && _inspectionResult$pay.success && (inspectionResult === null || inspectionResult === void 0 || (_inspectionResult$pay2 = inspectionResult.payload) === null || _inspectionResult$pay2 === void 0 || (_inspectionResult$pay2 = _inspectionResult$pay2.payload) === null || _inspectionResult$pay2 === void 0 || (_inspectionResult$pay2 = _inspectionResult$pay2.value) === null || _inspectionResult$pay2 === void 0 ? void 0 : _inspectionResult$pay2.statusCode) == 200) {
                        setLocalStorageItem(LOCAL_STORAGE_KEYS.MODULE_SECTION_INSPECTION, inspectionResult === null || inspectionResult === void 0 || (_inspectionResult$pay3 = inspectionResult.payload) === null || _inspectionResult$pay3 === void 0 || (_inspectionResult$pay3 = _inspectionResult$pay3.payload) === null || _inspectionResult$pay3 === void 0 || (_inspectionResult$pay3 = _inspectionResult$pay3.value) === null || _inspectionResult$pay3 === void 0 ? void 0 : _inspectionResult$pay3.data);
                    }
                    //jobCard result
                    if (jobCardResult !== null && jobCardResult !== void 0 && (_jobCardResult$payloa5 = jobCardResult.payload) !== null && _jobCardResult$payloa5 !== void 0 && (_jobCardResult$payloa5 = _jobCardResult$payloa5.payload) !== null && _jobCardResult$payloa5 !== void 0 && (_jobCardResult$payloa5 = _jobCardResult$payloa5.value) !== null && _jobCardResult$payloa5 !== void 0 && _jobCardResult$payloa5.success && (jobCardResult === null || jobCardResult === void 0 || (_jobCardResult$payloa6 = jobCardResult.payload) === null || _jobCardResult$payloa6 === void 0 || (_jobCardResult$payloa6 = _jobCardResult$payloa6.payload) === null || _jobCardResult$payloa6 === void 0 || (_jobCardResult$payloa6 = _jobCardResult$payloa6.value) === null || _jobCardResult$payloa6 === void 0 ? void 0 : _jobCardResult$payloa6.statusCode) == 200) {
                        setLocalStorageItem(LOCAL_STORAGE_KEYS.MODULE_SECTION_JOBCARD, jobCardResult === null || jobCardResult === void 0 || (_jobCardResult$payloa7 = jobCardResult.payload) === null || _jobCardResult$payloa7 === void 0 || (_jobCardResult$payloa7 = _jobCardResult$payloa7.payload) === null || _jobCardResult$payloa7 === void 0 || (_jobCardResult$payloa7 = _jobCardResult$payloa7.value) === null || _jobCardResult$payloa7 === void 0 ? void 0 : _jobCardResult$payloa7.data);
                    }
                    if (finalInspectionResult !== null && finalInspectionResult !== void 0 && (_finalInspectionResul4 = finalInspectionResult.payload) !== null && _finalInspectionResul4 !== void 0 && (_finalInspectionResul4 = _finalInspectionResul4.payload) !== null && _finalInspectionResul4 !== void 0 && (_finalInspectionResul4 = _finalInspectionResul4.value) !== null && _finalInspectionResul4 !== void 0 && _finalInspectionResul4.success && (finalInspectionResult === null || finalInspectionResult === void 0 || (_finalInspectionResul5 = finalInspectionResult.payload) === null || _finalInspectionResul5 === void 0 || (_finalInspectionResul5 = _finalInspectionResul5.payload) === null || _finalInspectionResul5 === void 0 || (_finalInspectionResul5 = _finalInspectionResul5.value) === null || _finalInspectionResul5 === void 0 ? void 0 : _finalInspectionResul5.statusCode) == 200) {
                        setLocalStorageItem(LOCAL_STORAGE_KEYS.MODULE_SECTION_FINALINSPECTION, finalInspectionResult === null || finalInspectionResult === void 0 || (_finalInspectionResul6 = finalInspectionResult.payload) === null || _finalInspectionResul6 === void 0 || (_finalInspectionResul6 = _finalInspectionResul6.payload) === null || _finalInspectionResul6 === void 0 || (_finalInspectionResul6 = _finalInspectionResul6.value) === null || _finalInspectionResul6 === void 0 ? void 0 : _finalInspectionResul6.data);
                    }
                    _c.label = 10;
                case 10: return [2 /*return*/];
            }
        });
    }); };
    var getUserRolesandPersonalDetails = function (userDetails) { return __awaiter(void 0, void 0, void 0, function () {
        var _userDetails$data$Ass, _userDetails$data, _userDetails$data2, currRole;
        return __generator(this, function (_a) {
            currRole = (_userDetails$data$Ass = userDetails === null || userDetails === void 0 || (_userDetails$data = userDetails.data) === null || _userDetails$data === void 0 || (_userDetails$data = _userDetails$data.AssignedRole) === null || _userDetails$data === void 0 ? void 0 : _userDetails$data.find(function (it) { return it.DisplayName === 'Service Advisor'; })) !== null && _userDetails$data$Ass !== void 0 ? _userDetails$data$Ass : userDetails === null || userDetails === void 0 || (_userDetails$data2 = userDetails.data) === null || _userDetails$data2 === void 0 || (_userDetails$data2 = _userDetails$data2.AssignedRole) === null || _userDetails$data2 === void 0 ? void 0 : _userDetails$data2[0];
            if (selectedDesignation) {
                setValue(selectedDesignation === null || selectedDesignation === void 0 ? void 0 : selectedDesignation.DisplayName);
            }
            else {
                dispatch(setSelectedDesignation(currRole));
                setValue(currRole === null || currRole === void 0 ? void 0 : currRole.DisplayName);
                setLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_DESIGNATION, currRole);
            }
            getModuleSectionByChannel(currRole);
            return [2 /*return*/];
        });
    }); };
    var getUserProfileDetails = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _profileDetailsRespon, _profileDetailsRespon2, _profileDetailsRespon11, profileDetailsResponse, _profileDetailsRespon3, _profileDetailsRespon4, _profileDetailsRespon5, _profileDetailsRespon8, _profileDetailsRespon9, _profileDetailsRespon10, _resultedRole, _profileDetailsRespon6, _profileDetailsRespon7, base64, error_1, serviceAdviserRole, finalInspectorRole, resultedRole, moduleMenuListResponse, _assignedModule$paylo, _assignedModule$paylo2, _assignedModule$paylo3, request, assignedModule, _assignedModule$paylo4, _moduleMenuListRespon, _moduleMenuListRespon2, body, _moduleMenuListRespon3, updatedList, MenuSequence, newList, _moduleMenuListRespon4, _moduleMenuListRespon5, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 11, , 12]);
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "",
                            url: getUserProfileUrl
                        }))];
                case 1:
                    profileDetailsResponse = _a.sent();
                    if (!(profileDetailsResponse !== null && profileDetailsResponse !== void 0 && (_profileDetailsRespon = profileDetailsResponse.payload) !== null && _profileDetailsRespon !== void 0 && _profileDetailsRespon.success && profileDetailsResponse.payload.statusCode == 200 && (profileDetailsResponse === null || profileDetailsResponse === void 0 || (_profileDetailsRespon2 = profileDetailsResponse.payload) === null || _profileDetailsRespon2 === void 0 || (_profileDetailsRespon2 = _profileDetailsRespon2.data) === null || _profileDetailsRespon2 === void 0 || (_profileDetailsRespon2 = _profileDetailsRespon2.AssignedRole) === null || _profileDetailsRespon2 === void 0 ? void 0 : _profileDetailsRespon2.length) > 0)) return [3 /*break*/, 9];
                    getUserRolesandPersonalDetails(profileDetailsResponse === null || profileDetailsResponse === void 0 ? void 0 : profileDetailsResponse.payload);
                    setLocalStorageItem(USER_PROFILE_DATA, profileDetailsResponse === null || profileDetailsResponse === void 0 ? void 0 : profileDetailsResponse.payload);
                    dispatch(setState({
                        key: "profileAttachmentId",
                        value: profileDetailsResponse === null || profileDetailsResponse === void 0 || (_profileDetailsRespon3 = profileDetailsResponse.payload) === null || _profileDetailsRespon3 === void 0 || (_profileDetailsRespon3 = _profileDetailsRespon3.data) === null || _profileDetailsRespon3 === void 0 ? void 0 : _profileDetailsRespon3.AttachmentId
                    }));
                    if (!(profileDetailsResponse !== null && profileDetailsResponse !== void 0 && (_profileDetailsRespon4 = profileDetailsResponse.payload) !== null && _profileDetailsRespon4 !== void 0 && (_profileDetailsRespon4 = _profileDetailsRespon4.data) !== null && _profileDetailsRespon4 !== void 0 && _profileDetailsRespon4.IdentityId && profileDetailsResponse !== null && profileDetailsResponse !== void 0 && (_profileDetailsRespon5 = profileDetailsResponse.payload) !== null && _profileDetailsRespon5 !== void 0 && (_profileDetailsRespon5 = _profileDetailsRespon5.data) !== null && _profileDetailsRespon5 !== void 0 && _profileDetailsRespon5.AttachmentId)) return [3 /*break*/, 5];
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, downloadProfileAttachment(profileDetailsResponse === null || profileDetailsResponse === void 0 || (_profileDetailsRespon6 = profileDetailsResponse.payload) === null || _profileDetailsRespon6 === void 0 || (_profileDetailsRespon6 = _profileDetailsRespon6.data) === null || _profileDetailsRespon6 === void 0 ? void 0 : _profileDetailsRespon6.IdentityId, profileDetailsResponse === null || profileDetailsResponse === void 0 || (_profileDetailsRespon7 = profileDetailsResponse.payload) === null || _profileDetailsRespon7 === void 0 || (_profileDetailsRespon7 = _profileDetailsRespon7.data) === null || _profileDetailsRespon7 === void 0 ? void 0 : _profileDetailsRespon7.AttachmentId, DownloadProfilePicUrl)];
                case 3:
                    base64 = _a.sent();
                    if (base64) {
                        dispatch(setState({
                            key: "ProfilePicUrl",
                            value: base64
                        }));
                    }
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    console.error("downloadProfileAttachment error", error_1);
                    return [3 /*break*/, 5];
                case 5:
                    serviceAdviserRole = profileDetailsResponse === null || profileDetailsResponse === void 0 || (_profileDetailsRespon8 = profileDetailsResponse.payload) === null || _profileDetailsRespon8 === void 0 || (_profileDetailsRespon8 = _profileDetailsRespon8.data) === null || _profileDetailsRespon8 === void 0 || (_profileDetailsRespon8 = _profileDetailsRespon8.AssignedRole) === null || _profileDetailsRespon8 === void 0 ? void 0 : _profileDetailsRespon8.find(function (item) { return item.Name === EUserRole.ServiceAdvisor; });
                    finalInspectorRole = profileDetailsResponse === null || profileDetailsResponse === void 0 || (_profileDetailsRespon9 = profileDetailsResponse.payload) === null || _profileDetailsRespon9 === void 0 || (_profileDetailsRespon9 = _profileDetailsRespon9.data) === null || _profileDetailsRespon9 === void 0 || (_profileDetailsRespon9 = _profileDetailsRespon9.AssignedRole) === null || _profileDetailsRespon9 === void 0 ? void 0 : _profileDetailsRespon9.find(function (item) { return item.Name === EUserRole.FinalInspector; });
                    resultedRole = profileDetailsResponse === null || profileDetailsResponse === void 0 || (_profileDetailsRespon10 = profileDetailsResponse.payload) === null || _profileDetailsRespon10 === void 0 || (_profileDetailsRespon10 = _profileDetailsRespon10.data) === null || _profileDetailsRespon10 === void 0 || (_profileDetailsRespon10 = _profileDetailsRespon10.AssignedRole) === null || _profileDetailsRespon10 === void 0 ? void 0 : _profileDetailsRespon10[0];
                    moduleMenuListResponse = {};
                    if (!!assignedMenus) return [3 /*break*/, 8];
                    if (selectedDesignation) {
                        resultedRole = selectedDesignation;
                    }
                    else {
                        if (serviceAdviserRole) {
                            resultedRole = serviceAdviserRole;
                        }
                        else if (finalInspectorRole) {
                            resultedRole = finalInspectorRole;
                        }
                    }
                    if (!resultedRole) return [3 /*break*/, 8];
                    request = {
                        RoleId: resultedRole.RoleId
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "assignModuleDataList",
                            url: assignedModulesURL,
                            request: request
                        }))];
                case 6:
                    assignedModule = _a.sent();
                    setLocalStorageItem(LOCAL_STORAGE_KEYS.ASSIGNED_MODULEDATA, assignedModule === null || assignedModule === void 0 || (_assignedModule$paylo = assignedModule.payload) === null || _assignedModule$paylo === void 0 || (_assignedModule$paylo = _assignedModule$paylo.value) === null || _assignedModule$paylo === void 0 ? void 0 : _assignedModule$paylo.data);
                    if (!(assignedModule !== null && assignedModule !== void 0 && (_assignedModule$paylo2 = assignedModule.payload) !== null && _assignedModule$paylo2 !== void 0 && (_assignedModule$paylo2 = _assignedModule$paylo2.value) !== null && _assignedModule$paylo2 !== void 0 && _assignedModule$paylo2.success && (assignedModule === null || assignedModule === void 0 || (_assignedModule$paylo3 = assignedModule.payload) === null || _assignedModule$paylo3 === void 0 || (_assignedModule$paylo3 = _assignedModule$paylo3.value) === null || _assignedModule$paylo3 === void 0 ? void 0 : _assignedModule$paylo3.data.length) > 0)) return [3 /*break*/, 8];
                    body = {
                        ModuleId: assignedModule === null || assignedModule === void 0 || (_assignedModule$paylo4 = assignedModule.payload) === null || _assignedModule$paylo4 === void 0 || (_assignedModule$paylo4 = _assignedModule$paylo4.value) === null || _assignedModule$paylo4 === void 0 || (_assignedModule$paylo4 = _assignedModule$paylo4.data[0]) === null || _assignedModule$paylo4 === void 0 ? void 0 : _assignedModule$paylo4.ModuleId,
                        RoleId: resultedRole.RoleId
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "assignMenusByGroupData",
                            url: assignedMenusByGroupURL,
                            request: body
                        }))];
                case 7:
                    moduleMenuListResponse = _a.sent();
                    if ((_moduleMenuListRespon = moduleMenuListResponse) !== null && _moduleMenuListRespon !== void 0 && (_moduleMenuListRespon = _moduleMenuListRespon.payload) !== null && _moduleMenuListRespon !== void 0 && _moduleMenuListRespon.value.success && (_moduleMenuListRespon2 = moduleMenuListResponse) !== null && _moduleMenuListRespon2 !== void 0 && (_moduleMenuListRespon2 = _moduleMenuListRespon2.payload) !== null && _moduleMenuListRespon2 !== void 0 && (_moduleMenuListRespon2 = _moduleMenuListRespon2.value) !== null && _moduleMenuListRespon2 !== void 0 && _moduleMenuListRespon2.data) {
                        updatedList = (_moduleMenuListRespon3 = moduleMenuListResponse) === null || _moduleMenuListRespon3 === void 0 || (_moduleMenuListRespon3 = _moduleMenuListRespon3.payload) === null || _moduleMenuListRespon3 === void 0 || (_moduleMenuListRespon3 = _moduleMenuListRespon3.value) === null || _moduleMenuListRespon3 === void 0 || (_moduleMenuListRespon3 = _moduleMenuListRespon3.data) === null || _moduleMenuListRespon3 === void 0 ? void 0 : _moduleMenuListRespon3.map(function (item) { return _objectSpread(_objectSpread({}, item), {}, {
                            isSubMenuOpen: false
                        }); });
                        MenuSequence = updatedList === null || updatedList === void 0 ? void 0 : updatedList.sort(function (a, b) { return a.Sequence - b.Sequence; });
                        newList = MenuSequence.map(function (item) {
                            var subMenus = __spreadArray([], item.Menus, true);
                            var SubMenusSequence = subMenus === null || subMenus === void 0 ? void 0 : subMenus.sort(function (a, b) { return a.Sequence - b.Sequence; });
                            return _objectSpread(_objectSpread({}, item), {}, {
                                Menus: SubMenusSequence
                            });
                        });
                        setLocalStorageItem(LOCAL_STORAGE_KEYS.ASSIGNED_MENUS, newList);
                    }
                    else {
                        setLocalStorageItem(LOCAL_STORAGE_KEYS.ASSIGNED_MENUS, []);
                    }
                    _a.label = 8;
                case 8:
                    if (!rbac) {
                        setRbacStorage((_moduleMenuListRespon4 = (_moduleMenuListRespon5 = moduleMenuListResponse) === null || _moduleMenuListRespon5 === void 0 || (_moduleMenuListRespon5 = _moduleMenuListRespon5.payload) === null || _moduleMenuListRespon5 === void 0 || (_moduleMenuListRespon5 = _moduleMenuListRespon5.value) === null || _moduleMenuListRespon5 === void 0 ? void 0 : _moduleMenuListRespon5.data) !== null && _moduleMenuListRespon4 !== void 0 ? _moduleMenuListRespon4 : assignedMenus);
                    }
                    if (((_resultedRole = resultedRole) === null || _resultedRole === void 0 ? void 0 : _resultedRole.Name) === EUserRole.TeleCaller && window.location.href.includes('/dashboard')) {
                        navigate('/crmdashboard');
                    }
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    return [3 /*break*/, 10];
                case 9:
                    if ((profileDetailsResponse === null || profileDetailsResponse === void 0 || (_profileDetailsRespon11 = profileDetailsResponse.payload) === null || _profileDetailsRespon11 === void 0 || (_profileDetailsRespon11 = _profileDetailsRespon11.data) === null || _profileDetailsRespon11 === void 0 || (_profileDetailsRespon11 = _profileDetailsRespon11.AssignedRole) === null || _profileDetailsRespon11 === void 0 ? void 0 : _profileDetailsRespon11.length) <= 0) {
                        dispatch(showLoader({
                            isLoaderOpen: false
                        }));
                        setRoleEmpty(true);
                        // dispatch( showNotification({ isOpen: true,message:"Role is not configured in the system, please configure the role against this user.",type: "error"}))
                    }
                    _a.label = 10;
                case 10: return [3 /*break*/, 12];
                case 11:
                    error_2 = _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    console.error('headerMenus::getUserProfileDetails::', error_2);
                    return [3 /*break*/, 12];
                case 12: return [2 /*return*/];
            }
        });
    }); };
    var getProductIssueConfiguration = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _result$payload, _result$payload2, _result$payload3, request, result, _result$payload4, _multipleDocArray$Val, _multipleDocArray, multipleDocArray, multipleDocValue;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    request = {
                        OrganizationId: storedSelectedBranch !== null && storedSelectedBranch !== void 0 && storedSelectedBranch.OrganizationId ? storedSelectedBranch === null || storedSelectedBranch === void 0 ? void 0 : storedSelectedBranch.OrganizationId : "",
                        ChannelId: storedSelectedChannel !== null && storedSelectedChannel !== void 0 && storedSelectedChannel.ChannelId ? storedSelectedChannel === null || storedSelectedChannel === void 0 ? void 0 : storedSelectedChannel.ChannelId : ""
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: getProductIssueConfigurationURL,
                            request: request
                        }))];
                case 1:
                    result = _a.sent();
                    if (result !== null && result !== void 0 && (_result$payload = result.payload) !== null && _result$payload !== void 0 && (_result$payload = _result$payload.value) !== null && _result$payload !== void 0 && _result$payload.success && (result === null || result === void 0 || (_result$payload2 = result.payload) === null || _result$payload2 === void 0 || (_result$payload2 = _result$payload2.value) === null || _result$payload2 === void 0 ? void 0 : _result$payload2.statusCode) == 200 && (result === null || result === void 0 || (_result$payload3 = result.payload) === null || _result$payload3 === void 0 || (_result$payload3 = _result$payload3.value) === null || _result$payload3 === void 0 || (_result$payload3 = _result$payload3.data) === null || _result$payload3 === void 0 || (_result$payload3 = _result$payload3.AllocationSubTypes) === null || _result$payload3 === void 0 ? void 0 : _result$payload3.length) > 0) {
                        multipleDocArray = [];
                        multipleDocArray = result === null || result === void 0 || (_result$payload4 = result.payload) === null || _result$payload4 === void 0 || (_result$payload4 = _result$payload4.value) === null || _result$payload4 === void 0 || (_result$payload4 = _result$payload4.data) === null || _result$payload4 === void 0 ? void 0 : _result$payload4.AllocationSubTypes.find(function (item) { return item.Key === SPARE_ISSUE_ENUM.MultipleDocument; });
                        multipleDocValue = (_multipleDocArray$Val = (_multipleDocArray = multipleDocArray) === null || _multipleDocArray === void 0 ? void 0 : _multipleDocArray.Value) !== null && _multipleDocArray$Val !== void 0 ? _multipleDocArray$Val : false;
                        setLocalStorageItem(LOCAL_STORAGE_KEYS.SPARE_ISSUE_MULTIPLE_DOC, multipleDocValue);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleProfilClick = function () {
        setProfileClick(!profileClick);
        setAnchorEl(null);
    };
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget.parentElement);
    };
    var handleClickPlusIcon = function (event) {
        setAddIconAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var handleCloseNewDocumentMenu = function () {
        setAddIconAnchorEl(null);
    };
    var handleChange = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var _userData$data4, resultedRole, variant, _assignedModule$paylo5, _assignedModule$paylo6, request, assignedModule, _assignedModule$paylo7, _moduleMenuListRespon6, _moduleMenuListRespon7, body, moduleMenuListResponse, _moduleMenuListRespon8, _moduleMenuListRespon9, updatedList, MenuSequence, newList, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 4, , 5]);
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    setLocalStorageItem(LOCAL_STORAGE_KEYS.ASSIGNED_MENUS, []);
                    setValue(event.target.value);
                    resultedRole = userData === null || userData === void 0 || (_userData$data4 = userData.data) === null || _userData$data4 === void 0 || (_userData$data4 = _userData$data4.AssignedRole) === null || _userData$data4 === void 0 ? void 0 : _userData$data4.find(function (item) { return item.DisplayName === event.target.value; });
                    dispatch(setIsAllViewActive(false));
                    dispatch(setSelectedDesignation(resultedRole));
                    setLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_DESIGNATION, resultedRole);
                    variant = resultedRole.Name == EUserRole.FinalInspector ? 'Job card' : "Appointments";
                    setLocalStorageItem(LOCAL_STORAGE_KEYS.DASHBOARD_SELECTED_VARIANT, variant);
                    setLocalStorageItem(LOCAL_STORAGE_KEYS.FILTER_FROM_DATE, resultedRole.Name === EUserRole.FloorSupervisor ? dateFormate(dateBeforeMonth) : dateFormate(dateBeforeWeek));
                    setLocalStorageItem(LOCAL_STORAGE_KEYS.FILTER_TO_DATE, dateFormate(new Date()));
                    if (!resultedRole) return [3 /*break*/, 3];
                    getModuleSectionByChannel(resultedRole);
                    request = {
                        RoleId: resultedRole.RoleId
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "assignModuleDataList",
                            url: assignedModulesURL,
                            request: request
                        }))];
                case 1:
                    assignedModule = _a.sent();
                    if (!(assignedModule !== null && assignedModule !== void 0 && (_assignedModule$paylo5 = assignedModule.payload) !== null && _assignedModule$paylo5 !== void 0 && (_assignedModule$paylo5 = _assignedModule$paylo5.value) !== null && _assignedModule$paylo5 !== void 0 && _assignedModule$paylo5.success && (assignedModule === null || assignedModule === void 0 || (_assignedModule$paylo6 = assignedModule.payload) === null || _assignedModule$paylo6 === void 0 || (_assignedModule$paylo6 = _assignedModule$paylo6.value) === null || _assignedModule$paylo6 === void 0 ? void 0 : _assignedModule$paylo6.data.length) > 0)) return [3 /*break*/, 3];
                    body = {
                        ModuleId: assignedModule === null || assignedModule === void 0 || (_assignedModule$paylo7 = assignedModule.payload) === null || _assignedModule$paylo7 === void 0 || (_assignedModule$paylo7 = _assignedModule$paylo7.value) === null || _assignedModule$paylo7 === void 0 || (_assignedModule$paylo7 = _assignedModule$paylo7.data[0]) === null || _assignedModule$paylo7 === void 0 ? void 0 : _assignedModule$paylo7.ModuleId,
                        RoleId: resultedRole.RoleId
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "assignMenusByGroupData",
                            url: assignedMenusByGroupURL,
                            request: body
                        }))];
                case 2:
                    moduleMenuListResponse = _a.sent();
                    if (moduleMenuListResponse !== null && moduleMenuListResponse !== void 0 && (_moduleMenuListRespon6 = moduleMenuListResponse.payload) !== null && _moduleMenuListRespon6 !== void 0 && _moduleMenuListRespon6.value.success && moduleMenuListResponse !== null && moduleMenuListResponse !== void 0 && (_moduleMenuListRespon7 = moduleMenuListResponse.payload) !== null && _moduleMenuListRespon7 !== void 0 && (_moduleMenuListRespon7 = _moduleMenuListRespon7.value) !== null && _moduleMenuListRespon7 !== void 0 && _moduleMenuListRespon7.data) {
                        setRbacStorage(moduleMenuListResponse === null || moduleMenuListResponse === void 0 || (_moduleMenuListRespon8 = moduleMenuListResponse.payload) === null || _moduleMenuListRespon8 === void 0 || (_moduleMenuListRespon8 = _moduleMenuListRespon8.value) === null || _moduleMenuListRespon8 === void 0 ? void 0 : _moduleMenuListRespon8.data);
                        updatedList = moduleMenuListResponse === null || moduleMenuListResponse === void 0 || (_moduleMenuListRespon9 = moduleMenuListResponse.payload) === null || _moduleMenuListRespon9 === void 0 || (_moduleMenuListRespon9 = _moduleMenuListRespon9.value) === null || _moduleMenuListRespon9 === void 0 || (_moduleMenuListRespon9 = _moduleMenuListRespon9.data) === null || _moduleMenuListRespon9 === void 0 ? void 0 : _moduleMenuListRespon9.map(function (item) { return _objectSpread(_objectSpread({}, item), {}, {
                            isSubMenuOpen: false
                        }); });
                        MenuSequence = updatedList === null || updatedList === void 0 ? void 0 : updatedList.sort(function (a, b) { return a.Sequence - b.Sequence; });
                        newList = MenuSequence.map(function (item) {
                            var subMenus = __spreadArray([], item.Menus, true);
                            var SubMenusSequence = subMenus === null || subMenus === void 0 ? void 0 : subMenus.sort(function (a, b) { return a.Sequence - b.Sequence; });
                            return _objectSpread(_objectSpread({}, item), {}, {
                                Menus: SubMenusSequence
                            });
                        });
                        setLocalStorageItem(LOCAL_STORAGE_KEYS.ASSIGNED_MENUS, newList);
                    }
                    else {
                        setLocalStorageItem(LOCAL_STORAGE_KEYS.ASSIGNED_MENUS, []);
                    }
                    _a.label = 3;
                case 3:
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    navigate("/dashboard");
                    return [3 /*break*/, 5];
                case 4:
                    e_1 = _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    console.error("Error-", e_1);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var formateDdMm = function (item) {
        if (item < 10) {
            return "0".concat(item);
        }
        else {
            return item;
        }
    };
    var dateFormate = function (date) {
        var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        var objectDate = new Date(date);
        var d = objectDate.getDate();
        var month = monthNames[objectDate.getMonth()];
        var y = objectDate.getFullYear();
        var dd = formateDdMm(d);
        return "".concat(month, " ").concat(dd, ", ").concat(y);
    };
    var handleCancleClick = function () {
        setIsSignOut(!isSignOut);
    };
    var handleSignOutClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            Post(logOutURL, undefined, {
                headers: {
                    Authorization: "bearer ".concat(getUserAuthToken())
                }
            }).then(function (res) {
                dispatch(showSuccess(res === null || res === void 0 ? void 0 : res.data));
            }).catch(function (e) {
                console.log(e);
            });
            navigate('/');
            clearLocalStorage();
            setIsSignOut(!isSignOut);
            dispatch(setState({
                key: 'clearStorage',
                value: true
            }));
            dispatch(resetCommonReducer());
            dispatch(resetAfterLogOutCrud());
            dispatch(resetAfterLogOutAuth());
            if (env === "dev" || env === "lt") {
                ChitraLogout();
            }
            return [2 /*return*/];
        });
    }); };
    var onClickLogOut = function () {
        setIsSignOut(!isSignOut);
        setAnchorEl(null);
    };
    var handleRedirection = function () {
        window.open(helpUrl, '_blank'); // Open the URL in a new tab
    };
    var onClickNewDocumentMenu = function (item) {
        switch (item) {
            case E_NEW_DOCUMENT_MENU_LIST.NEW_APPOINTMENT:
                navigate('/appointment-create');
                break;
            case E_NEW_DOCUMENT_MENU_LIST.NEW_INSPECTION:
                navigate('/create-inspection');
                break;
            case E_NEW_DOCUMENT_MENU_LIST.NEW_ESTIMATE:
                navigate('/serviceEstimate-create');
                break;
            default:
                break;
        }
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: 'center'
    }, (IS_DESKTOP || IS_TABLET) && /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 2
    }, (selectedDesignation === null || selectedDesignation === void 0 ? void 0 : selectedDesignation.Name) === EUserRole.ServiceAdvisor && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(MuiIconButton, {
        id: "header-add-btn",
        color: "primary",
        size: "large",
        sx: {
            borderRadius: '50%',
            backgroundColor: systemColor.white,
            ':active': {
                backgroundColor: systemColor.white
            },
            ':focus': {
                backgroundColor: systemColor.white
            },
            ':visited': {
                backgroundColor: systemColor.white
            },
            ':hover': {
                backgroundColor: systemColor.white
            }
        },
        onClick: handleClickPlusIcon
    }, /*#__PURE__*/ React.createElement(PlusHeaderIcon, {
        color: "primary"
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        borderRight: "1px white solid"
    })), /*#__PURE__*/ React.createElement(Button, {
        href: "/dashboard"
    }, /*#__PURE__*/ React.createElement(HomeIcon, {
        id: "homeBtn",
        width: "20px",
        height: "20px",
        color: "white"
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        borderRight: "1px white solid"
    })), /*#__PURE__*/ React.createElement(MuiStack, null, lgMode && /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 1,
        alignItems: 'center',
        py: 1,
        px: 1.5
    }, /*#__PURE__*/ React.createElement(Avatar, {
        src: ProfilePicUrl
    }), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column",
        justifyContent: 'center'
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "lg",
        fontWeight: "medium",
        color: 'white'
    }, userData === null || userData === void 0 || (_userData$data5 = userData.data) === null || _userData$data5 === void 0 ? void 0 : _userData$data5.GivenName, " ", userData === null || userData === void 0 || (_userData$data6 = userData.data) === null || _userData$data6 === void 0 ? void 0 : _userData$data6.FamilyName), /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "sm",
        color: "primary.100"
    }, value)))), downSM && Module === isModuleConfig.Bajaj ? /*#__PURE__*/ React.createElement(Button, {
        href: "/dashboard"
    }, /*#__PURE__*/ React.createElement(HomeIcon, {
        id: "homeBtn",
        width: "20px",
        height: "20px",
        color: "white"
    })) : /*#__PURE__*/ React.createElement(React.Fragment, null, !IS_DESKTOP && /*#__PURE__*/ React.createElement(MuiStack, null, false && /*#__PURE__*/ React.createElement(MuiIconButton, null, /*#__PURE__*/ React.createElement(HeaderSearchIcon, {
        sx: {
            width: '20px',
            height: '20px'
        },
        onClick: function () { return dispatch(setReducerState({
            key: "enableSearchInput",
            value: true
        })); }
    })), false && /*#__PURE__*/ React.createElement(MuiIconButton, null, /*#__PURE__*/ React.createElement(HeaderBellIcon, {
        sx: {
            width: '20px',
            height: '20px'
        }
    })))), /*#__PURE__*/ React.createElement(IconButton, {
        id: "moreMenuIcon",
        onClick: handleClick
    }, /*#__PURE__*/ React.createElement("img", {
        src: DotsVerticalIcon,
        alt: "more",
        style: {
            height: '24px',
            width: '24px'
        },
        loading: "lazy"
    }))), /*#__PURE__*/ React.createElement(Menu, {
        anchorEl: anchorEl,
        id: "account-menu",
        open: open,
        disableScrollLock: true,
        onClose: handleClose,
        sx: {
            overflow: 'visible',
            mt: 0.3,
            borderRadius: "8px"
        },
        transformOrigin: {
            horizontal: 'right',
            vertical: 'top'
        },
        anchorOrigin: {
            horizontal: 'right',
            vertical: 'bottom'
        }
    }, /*#__PURE__*/ React.createElement(Stack, {
        direction: "column",
        width: "240px"
    }, /*#__PURE__*/ React.createElement(MenuItem, {
        sx: {
            padding: "12px 16px 12px 16px"
        }
    }, /*#__PURE__*/ React.createElement(ListItemAvatar, null, /*#__PURE__*/ React.createElement(Avatar, {
        src: ProfilePicUrl,
        id: "advisor-profile-img",
        sx: {
            width: 40,
            height: 40
        }
    })), /*#__PURE__*/ React.createElement(Box, null, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "md",
        fontWeight: "medium",
        id: "service-advisor-name-menu"
    }, userData === null || userData === void 0 || (_userData$data7 = userData.data) === null || _userData$data7 === void 0 ? void 0 : _userData$data7.GivenName, " ", userData === null || userData === void 0 || (_userData$data8 = userData.data) === null || _userData$data8 === void 0 ? void 0 : _userData$data8.FamilyName), /*#__PURE__*/ React.createElement(Typography, {
        style: {
            fontSize: "12px"
        },
        color: "text.tertiary"
    }, value))), /*#__PURE__*/ React.createElement(Divider, null), /*#__PURE__*/ React.createElement(MenuItem, {
        onClick: handleProfilClick
    }, /*#__PURE__*/ React.createElement("img", {
        alt: "profile",
        src: ProfileIcon,
        width: '16px',
        height: '16px',
        id: "profileIcon"
    }), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3",
        id: "myAccount",
        style: {
            marginLeft: '10px'
        }
    }, t("My account"))), showRoles && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Divider, null), /*#__PURE__*/ React.createElement(Typography, {
        id: "switchRole",
        variant: "h3",
        px: 2,
        py: 1
    }, t("Switch role")), /*#__PURE__*/ React.createElement(FormControl, null, /*#__PURE__*/ React.createElement(RadioGroup, {
        id: "role",
        value: value,
        onChange: handleChange
    }, userData === null || userData === void 0 || (_userData$data9 = userData.data) === null || _userData$data9 === void 0 || (_userData$data9 = _userData$data9.AssignedRole) === null || _userData$data9 === void 0 || (_userData$data9 = _userData$data9.filter(function (item) { return (item === null || item === void 0 ? void 0 : item.Name) !== EUserRole.Default; })) === null || _userData$data9 === void 0 ? void 0 : _userData$data9.map(function (item, index) {
        return /*#__PURE__*/ React.createElement(MenuItem, {
            dense: true
        }, /*#__PURE__*/ React.createElement(FormControlLabel, {
            key: index,
            id: "role" + index,
            value: item === null || item === void 0 ? void 0 : item.DisplayName,
            control: /*#__PURE__*/ React.createElement(Radio, {
                sx: {
                    p: 0.5
                }
            }),
            label: item === null || item === void 0 ? void 0 : item.DisplayName,
            sx: {
                m: 0
            },
            componentsProps: {
                typography: {
                    sx: {
                        fontWeight: "medium"
                    }
                }
            }
        }));
    })))), /*#__PURE__*/ React.createElement(Divider, {
        flexItem: true,
        sx: {
            my: 1
        }
    }), /*#__PURE__*/ React.createElement(MenuItem, {
        onClick: handleRedirection
    }, /*#__PURE__*/ React.createElement("img", {
        id: "helpIcon",
        src: HelpIcon,
        width: '16px',
        height: '16px'
    }), /*#__PURE__*/ React.createElement(Typography, {
        id: "helpBtn",
        variant: "h3",
        style: {
            marginLeft: '10px'
        }
    }, t("Help"))), /*#__PURE__*/ React.createElement(Divider, null), /*#__PURE__*/ React.createElement(MenuItem, {
        onClick: onClickLogOut
    }, /*#__PURE__*/ React.createElement("img", {
        alt: "logout",
        src: logOutNew,
        width: '16px',
        height: '16px',
        id: "logoutIcon"
    }), /*#__PURE__*/ React.createElement(Typography, {
        id: "logoutBtn",
        variant: "h3",
        style: {
            marginLeft: '10px'
        }
    }, t("Logout"))))), /*#__PURE__*/ React.createElement(Menu, {
        anchorEl: addIconAnchorEl,
        id: "new-document-menu",
        open: openNewDocumentsMenu,
        onClose: handleCloseNewDocumentMenu,
        sx: {
            overflow: 'visible',
            mt: 0.3,
            borderRadius: "8px"
        },
        transformOrigin: {
            horizontal: 'left',
            vertical: 'top'
        },
        anchorOrigin: {
            horizontal: 'left',
            vertical: 'bottom'
        },
        MenuListProps: {
            'aria-labelledby': 'basic-button',
            sx: {
                padding: 0,
                whiteSpace: 'nowrap'
            }
        },
        slotProps: {
            paper: {
                sx: {
                    boxShadow: "0px 4px 6px -2px rgba(16, 24, 40, 0.03), 0px 12px 16px -4px rgba(16, 24, 40, 0.08)",
                    borderRadius: '8px',
                    border: '1px solid #DEE4EB'
                }
            }
        },
        disableScrollLock: true
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        width: '200px'
    }, /*#__PURE__*/ React.createElement(MenuList, {
        sx: {
            width: '100%',
            padding: 0
        }
    }, E_NEW_DOCUMENT_MENU_LIST && ((_Object$values = Object.values(E_NEW_DOCUMENT_MENU_LIST)) === null || _Object$values === void 0 ? void 0 : _Object$values.map(function (item, index) {
        return /*#__PURE__*/ React.createElement(MenuItem, {
            id: "new-document-".concat(index),
            dense: true,
            key: index,
            sx: {
                width: '100%',
                height: '42px',
                borderBottom: index === Object.values(E_NEW_DOCUMENT_MENU_LIST).length - 1 ? "none" : '1px solid #DEE4EB',
                fontWeight: '500',
                fontSize: '14px',
                fontFamily: 'NotoSans-Medium',
                textTransform: 'capitalize',
                whiteSpace: 'nowrap'
            },
            onClick: function () {
                onClickNewDocumentMenu(item);
                handleCloseNewDocumentMenu();
            }
        }, t(item));
    }))))), /*#__PURE__*/ React.createElement(MuiPopup, {
        showLoaderOnPopup: true,
        openPopup: profileClick,
        title: t("My account"),
        closeIcon: true,
        onClose: handleProfilClick,
        backdropEnable: true,
        containerStyle: {
            padding: '0px 8px 0px 8px',
            width: lgMode ? '500px' : 'calc(80vw)',
            height: '70vh'
        }
    }, /*#__PURE__*/ React.createElement(Profile, {
        onBackclick: function () { return setProfileClick(!profileClick); },
        onClosePopup: function (value) {
            setProfileClick(value);
        }
    })), /*#__PURE__*/ React.createElement(MuiPopup, {
        id: "popupId",
        title: t('Sign Out'),
        variant: "h1",
        subTitle: t("Are you sure you want to signout?"),
        openPopup: isSignOut,
        onClose: handleCancleClick,
        containerStyle: {
            width: '100%'
        },
        lgMode: lgMode
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: 1.5,
        justifyContent: "center"
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        id: "cancelButton",
        variant: "outlined",
        size: "large",
        name: t("CANCEL"),
        onClick: handleCancleClick
    })), /*#__PURE__*/ React.createElement(Grid, {
        item: true
    }, /*#__PURE__*/ React.createElement(MuiLoaderButton, {
        id: "confirmButton",
        variant: "contained",
        size: "large",
        name: t("CONFIRM"),
        onClick: handleSignOutClick
    })))), roleEmpty && /*#__PURE__*/ React.createElement(MuiPopup, {
        variant: "h1",
        openPopup: roleEmpty,
        closeIcon: true,
        backdropEnable: true,
        onClose: function () {
            handleSignOutClick();
            setRoleEmpty(false);
        },
        padding: '15px 0px 0px 15px',
        headerIcon: FeaturedRedIcon
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        flexDirection: 'column'
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "caption"
    }, t('Role not configured')), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h4",
        color: '#6A7682',
        marginTop: 1
    }, t("Role is not configured in the system, please configure the role against this user."))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        lg: 5,
        md: 5,
        sm: 5,
        xs: 6,
        sx: {
            display: 'flex',
            justifyContent: "flex-end",
            marginTop: '10px'
        }
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        id: "confirmButton",
        variant: "contained",
        size: "small",
        color: "primary",
        name: t("OK"),
        onClick: handleSignOutClick
    }))));
};
